/* istanbul ignore file */

import "./Page.css";
import { Footer, Header, PageBanner } from "../../components";
import * as React from "react";
import { Component, ReactNode } from "react";
import * as PropTypes from "prop-types";
import { componentWithName } from "airbnb-prop-types";
import ReactHelmet from "react-helmet";
import { StaticQuery, graphql } from "gatsby";

interface PageProps extends React.HTMLAttributes<HTMLDivElement> {
  layout?: string;
  sidebar?: ReactNode;
  title?: string;
}

function getLayoutClassNameFromProps(props: PageProps): string | null {
  if (!props.layout) {
    return null;
  }
  return `layout--${props.layout}`;
}

/**
 * The base page wrapper component.
 * More page layouts should be based off of this component.
 */
class BasePageLayout extends Component<PageProps> {
  public static readonly propTypes = {
    children: PropTypes.node,
    layout: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string,
    // TODO: Couldn't figure out how to check for actual Sidebar component.
    sidebar: componentWithName("Sidebar")
  };

  public static readonly defaultProps = {
    layout: "default",
    sidebar: null
  };

  public render(): JSX.Element {
    let layoutClassName = getLayoutClassNameFromProps(this.props);

    return (
      <StaticQuery
        query={graphql`
          query {
            site {
              siteMetadata {
                description
              }
            }
            banner: contentfulPageBanner(title: { eq: "Site Banner" }) {
              title
              isActive
              body {
                childContentfulRichText {
                  html
                }
              }
            }
          }
        `}
        render={data => (
          <div id="site__container" className={layoutClassName}>
            <ReactHelmet>
              <title>{this.props.title}</title>
              <meta
                name="description"
                content={data.site.siteMetadata.description}
              />
            </ReactHelmet>
            <Header />
            {this.props.sidebar}
            <main role="main" className={this.props.className}>
              <PageBanner {...data.banner} />

              {/* <div className="banner" style={{ marginBottom: "16px" }}>
                <PageContent style={{ textAlign: "center" }}>
                  <a
                    title="Visit our news page for Hawaiiana’s COVID-19 Update"
                    href="/news"
                    style={{
                      textDecorationColor: "red"
                    }}
                  >
                    <em
                      style={{
                        color: "red",
                        fontWeight: "bold",
                        fontSize: "2em"
                      }}
                    >
                      Click here for Hawaiiana’s COVID-19 Update
                    </em>
                  </a>
                </PageContent>
              </div> */}
              {this.props.children}
            </main>
            <Footer />
          </div>
        )}
      />
    );
  }
}

export default BasePageLayout;
